import React from "react";
import Headers from "../../../components/Headers";
import {
  Input,
  Row,
  Col,
  Button,
  Table,
  Modal,
  Select,
  DatePicker,
} from "antd";
import NProgress from "nprogress";
import { fetchVipRecord } from "../../../api/userInfo";

import "./index.scss";
const { RangePicker } = DatePicker;
const { Column } = Table;
const BreadCrumbData = [
  { path: "/page/ssry/userInfo", name: "试试如意" },
  { path: "/page/ssry/vipRecord", name: "会员购买记录" },
];

class VipRecord extends React.Component {
  state = {
    listQuery: {
      pageNum: 1,
      pageSize: 10,
      mobilePhone: "",
      capsuleNo: "",
      beginTime: "",
      endTime: "",
    },
    list: [],
    total: 0,
  };
  dateChange = (date, dateString) => {
    this.setState({
      listQuery: {
        ...this.state.listQuery,
        beginTime: dateString[0],
        endTime: dateString[1],
      },
    });
  };
  getList = () => {
    fetchVipRecord(this.state.listQuery).then((res) => {
      if (res.success) {
        this.setState({
          list: res.data.list,
          total: res.data.total,
        });
      }
    });
  };
  componentDidMount() {
    NProgress.start();
    this.getList();
    NProgress.done();
  }
  handleSearch = () => {
    this.setState(
      {
        listQuery: { ...this.state.listQuery, pageNum: 1 },
      },
      () => this.getList()
    );
  };
  inputChange = (e) => {
    this.setState({
      listQuery: { ...this.state.listQuery, [e.target.name]: e.target.value },
    });
  };
  renderState = (record) => {
    switch (record.state) {
      case "USED":
        return <span style={{ color: "#F5A623" }}>已使用</span>;
        break;
      case "NOT_USED":
        return <span style={{ color: "#63B607" }}>未使用</span>;
        break;
      case "EXPIRE":
        return <span style={{ color: "#F5A623" }}>过期</span>;
        break;
      case "NOT_EXPIRE":
        return <span style={{ color: "#63B607" }}>正常</span>;
        break;
      default:
        break;
    }
  };
  render() {
    const { listQuery, list, total } = this.state;
    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="vipRecord_container">
          <div className="searchTop">
            <RangePicker
              className="marginR"
              onChange={this.dateChange}
              style={{ width: 250, marginRight: 10 }}
              allowClear
            />
            <Input
              style={{ width: 150 }}
              className="marginR"
              onChange={this.inputChange}
              name="capsuleNo"
              placeholder="设备编号"
              allowClear
            ></Input>
            <Input
              style={{ width: 150 }}
              className="marginR"
              onChange={this.inputChange}
              name="mobilePhone"
              placeholder="手机号码"
              allowClear
            ></Input>
            <Button type="primary" onClick={this.handleSearch}>
              搜索
            </Button>
          </div>
          <div className="content">
            <Table
              rowKey="tradeNo"
              dataSource={list}
              // locale={{ emptyText: "暂无商户" }}
              pagination={{
                showTotal: () => `共${total}条`,
                total: total,
                current: listQuery.pageNum,
                pageSize: listQuery.pageSize,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ["10", "20", "30", "40", "100"],
                onChange: (page, pageSize) => {
                  this.setState(
                    {
                      listQuery: { ...listQuery, pageNum: page },
                    },
                    () => this.getList()
                  );
                },
                onShowSizeChange: (current, pageSize) => {
                  this.setState(
                    {
                      listQuery: { ...listQuery, pageSize, pageNum: 1 },
                    },
                    () => this.getList()
                  );
                },
              }}
            >
              <Column title="下单时间" dataIndex="time" key="time" />
              <Column title="设备编号" dataIndex="capsuleNo" key="capsuleNo" />
              <Column title="设备位置" dataIndex="address" key="address" />
              <Column title="用户昵称" dataIndex="nickName" key="nickName" />
              <Column
                title="手机号码"
                dataIndex="mobilePhone"
                key="mobilePhone"
              />
              <Column title="购买会员费用/元" dataIndex="price" key="price" />
              <Column
                title="到期时间"
                dataIndex="expireTime"
                key="expireTime"
              />
              <Column title="状态" render={this.renderState} />
            </Table>
          </div>
        </div>
      </div>
    );
  }
}

export default VipRecord;
